export default function(date, sec = false) {
    if (date == null) return ''
    if (typeof date === 'number')
        date = new Date(date)
    if (sec)
        return date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true })
    return date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
}
